export default [
  {
    path: "/PerformancePart/PerformanceExportdetail",
    name: "PerformanceExportdetail",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceExportdetail/PerformanceExportdetail.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-案件明細匯出",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceIntermediarybrand",
    name: "PerformanceIntermediarybrand",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceIntermediarybrand/PerformanceIntermediarybrand.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-仲介品牌",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceIntermediaryarea",
    name: "PerformanceIntermediaryarea",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceIntermediaryarea/PerformanceIntermediaryarea.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-仲介區域",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceLAagentarea",
    name: "PerformanceLAagentarea",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceLAagentarea/PerformanceLAagentarea.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-代書區域",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBusiness",
    name: "PerformanceBusiness",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBusiness/PerformanceBusiness.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-業務",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceUndertake",
    name: "PerformanceUndertake",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceUndertake/PerformanceUndertake.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-流控",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBusinessarea",
    name: "PerformanceBusinessarea",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBusinessarea/PerformanceBusinessarea.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-業務區域",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBranddetail",
    name: "PerformanceBranddetail",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBranddetail/PerformanceBranddetail.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-品牌明細",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceUndertakearea",
    name: "PerformanceUndertakearea",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceUndertakearea/PerformanceUndertakearea.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-流控區域",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBranddetailmail",
    name: "PerformanceBranddetailmail",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBranddetailmail/PerformanceBranddetailmail.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效報表-品牌明細(Email)",
      breadcrumb: [
        {
          text: "績效報表",
          active: true,
        },
      ],
    },
  },

  {
    path: "/PerformancePart/PerformanceCalculatestandard",
    name: "PerformanceCalculatestandard",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceCalculatestandard/PerformanceCalculatestandard.vue"
      ),
    props: true,

    meta: {
      pageTitle: "績效計算標準設定維護",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceIntermediarycase",
    name: "PerformanceIntermediarycase",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceIntermediarycase/PerformanceIntermediarycase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "仲介件數相關報表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceLAagentcase",
    name: "PerformanceLAagentcase",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceLAagentcase/PerformanceLAagentcase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "代書件數相關報表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceUndertakeday",
    name: "PerformanceUndertakeday",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceUndertakeday/PerformanceUndertakeday.vue"
      ),
    props: true,

    meta: {
      pageTitle: "每日流控績效",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBusinessday",
    name: "PerformanceBusinessday",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBusinessday/PerformanceBusinessday.vue"
      ),
    props: true,

    meta: {
      pageTitle: "每日業務績效",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceNewcase",
    name: "PerformanceNewcase",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceNewcase/PerformanceNewcase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "每日新增件數表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceAccumulationcase",
    name: "PerformanceAccumulationcase",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceAccumulationcase/PerformanceAccumulationcase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "每日累積件數表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceAreasigncase",
    name: "PerformanceAreasigncase",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceAreasigncase/PerformanceAreasigncase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "各區簽約件數及送件店數表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceUndertakemonth",
    name: "PerformanceUndertakemonth",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceUndertakemonth/PerformanceUndertakemonth.vue"
      ),
    props: true,

    meta: {
      pageTitle: "流控績效月報表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBusinessmonth",
    name: "PerformanceBusinessmonth",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBusinessmonth/PerformanceBusinessmonth.vue"
      ),
    props: true,

    meta: {
      pageTitle: "業務績效月報表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceUndertakeyear",
    name: "PerformanceUndertakeyear",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceUndertakeyear/PerformanceUndertakeyear.vue"
      ),
    props: true,

    meta: {
      pageTitle: "流控季/年績效報表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceBusinessyear",
    name: "PerformanceBusinessyear",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceBusinessyear/PerformanceBusinessyear.vue"
      ),
    props: true,

    meta: {
      pageTitle: "業務季/年績效報表",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
  {
    path: "/PerformancePart/PerformanceHistorydata",
    name: "PerformanceHistorydata",
    component: () =>
      import(
        "@/views/pages/PerformancePart/PerformanceHistorydata/PerformanceHistorydata.vue"
      ),
    props: true,

    meta: {
      pageTitle: "歷史送件資料",
      breadcrumb: [
        {
          text: "新增案件績效計算",
          active: true,
        },
      ],
    },
  },
];
